interface IssueMonth {
  netIssuedQuantity: number | null;
}

/** Net issue quantity across the latest twelve completed months. */
export function getAnnualPartUsage(months: IssueMonth[]): number | null {
  const latestTwelve = months.slice(-12);
  if (
    latestTwelve.length !== 12 ||
    latestTwelve.some(({netIssuedQuantity}) => netIssuedQuantity === null)
  ) {
    return null;
  }
  const annualPartUsage = latestTwelve.reduce(
    (sum, {netIssuedQuantity}) => sum + (netIssuedQuantity ?? 0),
    0
  );
  return annualPartUsage;
}
